module.exports = "/img/user-guided-tours/customers-list/customize.png?a905852142a7ec01c634871295962876";